module.exports = "/lucky-balls/img/weager/balls/normal/LB_4.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/weager/balls/normal/LB_4.png
// module id = 1187
// module chunks = 0